export const mood = `#version 300 es
precision highp float;
#define PI 3.14159265359
uniform vec2 u_resolution;
uniform float u_time, u_siize, u_ws;
out vec4 final;

float map(float value, float min1, float max1, float min2, float max2) {
    return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
    }

float rectshape(vec2 position,vec2 scale){
   scale=vec2(.5)-scale*.5;
   vec2 shaper=vec2(step(scale.x,position.x),step(scale.y,position.y));
   shaper*=vec2(step(scale.x,1.-position.x),step(scale.y,1.-position.y));
   return shaper.x*shaper.y;}
   
void main(){

vec3 infinite = vec3(0.0549, 0.298*sin(u_time*0.00015), 0.9098);
vec3 dark = vec3(0.0471, 0.0039, 0.0392);

float h2 = map(u_siize, 0.0, 1.0, 0.05, 0.4);
float h3 = map(u_siize, 0.0, 1.0, 0.1, 0.8);//0.4
float h4 = map(u_siize, 0.0, 1.0, 0.05, 0.6);


vec3 a = vec3(0.5);


   vec2 position=gl_FragCoord.xy/u_resolution;
   vec3 color = infinite;
   float form = rectshape(position,vec2(h3,h2));

   if(u_ws > 0.0){
    form = rectshape(position,vec2(h4,h3));
   }



   
   if (form > 0.0) {
       color = dark;
   }
    
   final=vec4(color,1.);
}`